import React from 'react';
interface CTAButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
  variant?: 'primary' | 'secondary';
}
export function CTAButton({
  children,
  onClick,
  className = '',
  variant = 'primary'
}: CTAButtonProps) {
  const baseStyles = 'px-8 py-4 rounded-lg font-semibold text-lg transition-all duration-200 focus:outline-none focus:ring-4 focus:ring-offset-2';
  const variantStyles = {
    primary: 'bg-terracotta-500 text-white hover:bg-terracotta-600 focus:ring-terracotta-500/50',
    secondary: 'bg-teal-500 text-white hover:bg-teal-600 focus:ring-teal-500/50'
  };
  const handleClick = () => {
    window.location.href = 'https://www.leahfreedom.com/cart/47435003101405:1';
  };
  return <button onClick={handleClick} className={`${baseStyles} ${variantStyles[variant]} ${className}`} type="button" data-id="element-1">
      {children}
    </button>;
}